/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type HpRespPromoModulePrimaryOld_componentModule = {
    readonly title: string | null;
    readonly items: ReadonlyArray<{
        readonly cmsId: number | null;
        readonly imageCopy: string | null;
        readonly cta: string | null;
        readonly imageUrl?: string | null;
        readonly imageHeight?: string | null;
        readonly imageWidth?: string | null;
        readonly mobileImageUrl?: string | null;
        readonly mobileImageHeight?: string | null;
        readonly mobileImageWidth?: string | null;
        readonly linkData: {
            readonly path: string | null;
            readonly " $fragmentRefs": FragmentRefs<"SeoLink_linkData">;
        };
        readonly isFullBleedImage: boolean | null;
    } | null> | null;
    readonly " $refType": "HpRespPromoModulePrimaryOld_componentModule";
};
export type HpRespPromoModulePrimaryOld_componentModule$data = HpRespPromoModulePrimaryOld_componentModule;
export type HpRespPromoModulePrimaryOld_componentModule$key = {
    readonly " $data"?: HpRespPromoModulePrimaryOld_componentModule$data;
    readonly " $fragmentRefs": FragmentRefs<"HpRespPromoModulePrimaryOld_componentModule">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "HpRespPromoModulePrimaryOld_componentModule",
  "type": "PromoModule",
  "metadata": null,
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "isMobile",
      "type": "Boolean"
    }
  ],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "title",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "items",
      "storageKey": null,
      "args": null,
      "concreteType": "PromoItem",
      "plural": true,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "cmsId",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "imageCopy",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "cta",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "linkData",
          "storageKey": null,
          "args": null,
          "concreteType": "LinkData",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "path",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "FragmentSpread",
              "name": "SeoLink_linkData",
              "args": null
            }
          ]
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "isFullBleedImage",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "Condition",
          "passingValue": false,
          "condition": "isMobile",
          "selections": [
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "imageUrl",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "imageHeight",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "imageWidth",
              "args": null,
              "storageKey": null
            }
          ]
        },
        {
          "kind": "Condition",
          "passingValue": true,
          "condition": "isMobile",
          "selections": [
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "mobileImageUrl",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "mobileImageHeight",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "mobileImageWidth",
              "args": null,
              "storageKey": null
            }
          ]
        }
      ]
    }
  ]
};
(node as any).hash = '9f3fb6a682eac35eb322b8b5a1fb15ee';
export default node;
